import { useSession } from "@sg-protect/shell";
import { type PartnerTier, isPartnerTier } from "./partnerTiers.ts";

export function usePartnerTier(): PartnerTier | undefined {
    const { products } = useSession();
    const tier = products?.partner?.tier;

    return tier !== undefined && isPartnerTier(tier) ? tier : undefined;
}
